import { IrveFormBorne } from "@types"

/**
 * Permet de regrouper les bornes similaires
 * @param bornes bornes à regrouper
 */
export function groupSimilarBornes(
    bornes: {
        cos_phi: number
        puissanceactive_moyenne: number
        puissanceactive_nominale: number
    }[]
): IrveFormBorne[] {
    const groupedBornesMap: Map<string, IrveFormBorne> = new Map()
    // Regrouper les bornes similaires
    bornes.forEach((borne) => {
        const key = `${borne.cos_phi}-${borne.puissanceactive_moyenne}-${borne.puissanceactive_nominale}`
        if (groupedBornesMap.has(key)) {
            const existingBorne = groupedBornesMap.get(key)!
            existingBorne.quantity += 1
        } else {
            groupedBornesMap.set(key, {
                power: borne.puissanceactive_nominale,
                powerFactor: borne.cos_phi,
                powerMean: borne.puissanceactive_moyenne,
                quantity: 1,
            })
        }
    })
    // Retourner les bornes regroupées
    return Array.from(groupedBornesMap.values())
}
